import { tw } from "@soft-db/ui";
import { ColorEvaluator } from "./color-evaluator";

// tw is simply a template strings literal helper for lsp
// It does nothing more. We tag it as html, for syntax highlight
const html = tw;

export function svgUrl(svg: string): string {
	return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export function siteMarkerIcon(color: string) {
	const evaluator = new ColorEvaluator();

	const evaluatedColor = evaluator.evaluate(color);

	return html`
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
			<path fill="none" d="M0 0h24v24H0V0z" />
			<path
				fill="${evaluatedColor}"
				opacity="1"
				d="M17 9c0-2.76-2.24-5-5-5S7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.12-2.69 5-7 5-9.88zM9.5 9c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 10.38 9.5 9z"
			/>
			<path
				d="M19 9c0-3.87-3.13-7-7-7S5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13zm-7-5c2.76 0 5 2.24 5 5 0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9c0-2.76 2.24-5 5-5z"
			/>
			<circle cx="12" cy="9" r="2.5" />
		</svg>
	`;
}
